// no-op on web
export default ({ children }) => children;



// WEBPACK FOOTER //
// ./src/@ui/OnboardingModal/index.web.js